//import sprintf from 'sprintf-js';

// из строки получаем число
function getRecipeNum(src)
{    
    var sprintf = require('sprintf-js').sprintf;
    return sprintf("%05d", src);
}

export default getRecipeNum;